import React, { useState } from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import Tooltip from '@mui/material/Tooltip';
import Avator from '../Picture';
import ContentCard from '../../common/ContentCard';
import NotesLogo from '../../icons/Notes.svg';
import MissingNotesIcon from '../../icons/missingNotes.svg';
import PinIcon from '../../icons/location.svg';
import segmentPropTypes from './propTypes';
import './styles.scss';
import { noop } from '../propTypes';

function SegmentCollapsableCard({
    id,
    creatorName,
    avatar,
    date,
    litterCount,
    duration,
    distance,
    mapContent,
    tagsContent,
    onSegmentClick,
    activeSegmentId,
    title,
    landInfo,
    photos,
    loadingPhotos,
    onEditClick,
    onDeleteClick,
    userId,
    segmentHasNotes,
    // loggedInUser,
}) {
    const segmentCreatedByUser = true; //loggedInUser.id == userId;
    const [filter, setFilter] = useState('');
    const { land, sub_land: subLand } = landInfo || {};
    const TagsComponent = tagsContent;
    const { MapComponent, dropDownData, dropDownVariant, ICONS } = mapContent;
    let { center, dataPoints, zoom } = mapContent;

    let litterLocation = [];
    if (photos && photos.length) {
        litterLocation = photos.map(
            ({ photoLocation, classification, photo, thumbnail }) => ({
                lat: parseFloat(photoLocation.lat),
                lng: parseFloat(photoLocation.long),
                marker: ICONS[classification],
                classification,
                photo,
                thumbnail,
            }),
        );

        litterLocation = litterLocation.filter(
            (data) => !(data.lat === 0 || data.lng === 0),
        );
        litterLocation = filter
            ? litterLocation.filter((d) => d.classification == filter)
            : litterLocation;
    }
    return (
        <div className="segmentAccordainCards">
            <ContentCard
                showDropDown={false}
                content={
                    <Card className="d-flex accordion-card">
                        <Accordion.Collapse
                            eventKey={id}
                            className="segmentCardBody"
                        >
                            <Card.Body>
                                <Row>
                                    <Col md={6}>
                                        {
                                            <ContentCard
                                                heading={'Map'}
                                                showDropDown={true}
                                                dropDownData={dropDownData}
                                                dropDownLabel={'Filter By'}
                                                dropDownOnClick={setFilter}
                                                dropDownVariant={
                                                    dropDownVariant
                                                }
                                                content={
                                                    <>
                                                        {land && (
                                                            <div className="land-info">
                                                                <img
                                                                    src={
                                                                        PinIcon
                                                                    }
                                                                />
                                                                <label>{`${land}${
                                                                    subLand
                                                                        ? ` . ${subLand}`
                                                                        : ''
                                                                }`}</label>
                                                            </div>
                                                        )}
                                                        <MapComponent
                                                            id="segments-map"
                                                            drawPolyline={true}
                                                            center={center}
                                                            dataPoints={
                                                                dataPoints
                                                            }
                                                            zoom={zoom}
                                                            options={{
                                                                scrollwheel: false,
                                                                disableDefaultUI: true,
                                                                zoomControl: true,
                                                            }}
                                                            isLoading={
                                                                loadingPhotos
                                                            }
                                                            showMarkerWithPolyline={
                                                                !!(
                                                                    photos &&
                                                                    photos.length
                                                                )
                                                            }
                                                            markerPoints={
                                                                litterLocation
                                                            }
                                                        />
                                                    </>
                                                }
                                                className="h-100 segment-collapse-container"
                                            />
                                        }
                                    </Col>
                                    <Col md={6}>
                                        {activeSegmentId == id && (
                                            <TagsComponent
                                                segmentId={id}
                                                userId={userId}
                                            />
                                        )}
                                    </Col>
                                </Row>
                                {segmentCreatedByUser && (
                                    <Row>
                                        <button
                                            onClick={(e) => {
                                                onDeleteClick(id);
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }}
                                            className="delete-btn"
                                        >
                                            Delete
                                        </button>
                                    </Row>
                                )}
                            </Card.Body>
                        </Accordion.Collapse>
                        <Accordion.Toggle
                            as={Card.Header}
                            eventKey={id}
                            className="segmentCardHeader"
                            onClick={onSegmentClick}
                        >
                            <div className="row m-0">
                                <div className="col userInfo d-flex align-items-center">
                                    <Avator
                                        variant={'Medium'}
                                        source={avatar}
                                    />
                                    <div className="userName">
                                        <h4 className="title segmentName">
                                            {creatorName}
                                        </h4>
                                        <Tooltip title={title} placement="top">
                                            <h4 className="title">{title}</h4>
                                        </Tooltip>
                                        <small className="text-uppercase dateStamp">
                                            {date}
                                        </small>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="stats">
                                        <small className="title text-uppercase">
                                            Total Pieces
                                        </small>
                                        <div className="stat h2 text-primary">
                                            {litterCount}
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="stats">
                                        <small className="title text-uppercase">
                                            Distance
                                        </small>
                                        <div className="stat h2 text-primary">
                                            {distance}
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="stats">
                                        <small className="title text-uppercase">
                                            Duration
                                        </small>
                                        <div className="stat h2 text-primary">
                                            {duration}
                                        </div>
                                    </div>
                                </div>
                                {segmentHasNotes ? (
                                    <img
                                        onClick={(e) => {
                                            onEditClick(id);
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }}
                                        src={NotesLogo}
                                        className="noteslogo"
                                    />
                                ) : (
                                    <img
                                        onClick={(e) => {
                                            onEditClick(id);
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }}
                                        src={MissingNotesIcon}
                                        className="missingNoteslogo"
                                    />
                                )}
                                <button
                                    onClick={onSegmentClick}
                                    className="col-1 collapseBtn align-self-center text-right"
                                >
                                    <svg
                                        className="ico-arrowCollapse"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            fill="#000"
                                            fillRule="nonzero"
                                            d="M8.876 8.047l-3.3-3.3a.667.667 0 0 1 .943-.942l3.771 3.771c.26.26.26.682 0 .943L6.519 12.29a.667.667 0 0 1-.943-.943l3.3-3.3z"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </Accordion.Toggle>
                    </Card>
                }
            />
        </div>
    );
}

SegmentCollapsableCard.propTypes = segmentPropTypes;

SegmentCollapsableCard.defaultProps = {
    id: null,
    creatorName: 'John Doe',
    title: 'Segment Name',
    date: '01 Jan 1970',
    litterCount: '0',
    duration: '0 sec',
    distance: '0 m',
    mapContent: null,
    tagsContent: null,
    landInfo: null,
    isActive: false,
    onSegmentClick: noop,
    activeSegmentId: null,
};

export default SegmentCollapsableCard;
